import React, { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAlertWebsocket } from '../hooks/use-alert-websocket';
import clsx from 'clsx';

export const AlertOverlay = () => {
  useEffect(() => {
    const appFrame = document.getElementById('app-frame');
    const rootElement = document.getElementById('root');
    if (!appFrame || !rootElement) return;
    function transparentize(el?: HTMLElement) {
      if (!el) return;
      el.className = '';
      el.style.background = 'transparent';
    }
    transparentize(appFrame);
    transparentize(rootElement);
    transparentize(document.documentElement);
    transparentize(document.body);
  }, []);
  const { partnerId } = useParams();
  const { currentAlert } = useAlertWebsocket(partnerId || '');
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (currentAlert) {
      setShow(true);
    } else {
      setShow(false);
    }
  }, [currentAlert]);

  const costume = useMemo(
    () => `/gimmecat-legacy/images/cat-skins/${currentAlert?.payload.itemId}/display.png?url`,
    [currentAlert?.payload.itemId]
  );

  return (
    <div
      className={clsx(
        'bg-[transparent] w-full h-[100vh] text-white flex gap-4 px-4 pt-1 pb-1 transform transition-opacity duration-200 ease-in-out',
        show ? 'opacity-100' : 'opacity-0'
      )}
      style={{ WebkitTextStroke: '1px black' }}
    >
      <img src={costume} className="h-full" />
      <div className="flex flex-col gap-1">
        <p className="text-blue-400 font-bold text-3xl">Style boost!</p>
        <p className="text-white font-semibold text-2xl">
          {currentAlert?.payload.username} has purchased a costume in MeowMeow.
        </p>
      </div>
    </div>
  );
};
